// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bek_a bic_ea bic_ke bic_ju bic_sn bic_wl"};